import { render, staticRenderFns } from "./JVxePopupCell.vue?vue&type=template&id=0f292f37&scoped=true&"
import script from "./JVxePopupCell.vue?vue&type=script&lang=js&"
export * from "./JVxePopupCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f292f37",
  null
  
)

export default component.exports